export const checkExpireToday = (item) => {

  var dateItem = new Date(item.DataVencimento).setUTCHours(0,0,0,0);
  var dataatual = new Date().setUTCHours(0,0,0,0);
  var dividaQuitada = item.CodigoSituacao === 'Q' ? true : false

    if (dateItem === dataatual && !dividaQuitada) {
      return true
    }

    return false
}
